import styled from 'styled-components';

export const ScSliderContainer = styled.div`
  width: 100%;
  overflow: hidden;
  position: relative;
`;
